export default "__VITE_ASSET__335e7d27__"